import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

import { HtmlContent } from '../../global-component-styles';
import GlobalStyles from '../../global-styles';
import {
  Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Typography
} from '../../utils/material-ui-core';

interface ConfirmProps {
  title: string;
  content: string;
  yesText: string;
  noText: string;
  open: boolean;
  callbackOnClose: () => void;
  callbackOnConfirm: (confirm: boolean) => void;
}
const Confirm = ({ title, content, yesText, noText, open, callbackOnClose, callbackOnConfirm }: ConfirmProps) => {
  const pageStyles = LocalPageStyles();
  const globalStyles = GlobalStyles();

  return (
    <Dialog className={globalStyles.dialogContainer} open={open} maxWidth={"sm"} fullWidth={true} onClose={callbackOnClose}>
      <DialogTitle className={globalStyles.dialogTitleContainer}>
        <Typography variant="body1" component="div">
          {title}
        </Typography>
      </DialogTitle>
      <DialogContent dividers>
        <DialogContentText className={pageStyles.contentText} component="div">
          <HtmlContent dangerouslySetInnerHTML={{ __html: content }}></HtmlContent>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        {yesText === "DELETE" || yesText === "REMOVE" ? (
          <Button onClick={() => callbackOnConfirm(true)} color="default" variant="contained" autoFocus className={pageStyles.deleteButton}>
            {yesText}
          </Button>
        ) : (
          <Button onClick={() => callbackOnConfirm(true)} color="secondary" variant="contained" autoFocus className={globalStyles.buttonDefault}>
            {yesText}
          </Button>
        )}
        <Button onClick={() => callbackOnConfirm(false)} color="secondary" autoFocus className={globalStyles.buttonDefault}>
          {noText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const LocalPageStyles = makeStyles((theme: Theme) =>
  createStyles({
    contentText: {
      whiteSpace: "pre-wrap",
    },
    deleteButton: {
      backgroundColor: theme.palette.error.main,
      color: theme.palette.error.contrastText,
      marginLeft: "4px",
      marginRight: "4px",

      [theme.breakpoints.down("xs")]: {
        fontSize: 12,
      },
    },
  })
);

export default Confirm;
